/**
 * 発注一時保存ユーティリティ
 * localStorageを使用した一時保存・取得・削除機能
 */

const STORAGE_KEY = 'order_temp_save'

/**
 * ファイルオブジェクトからシリアライズ可能なデータを抽出
 * @param {Object} file - ファイルオブジェクト
 * @returns {Object} シリアライズ可能なファイル情報
 */
function serializeFile(file) {
  if (!file) return null

  return {
    accepted: file.accepted,
    count: file.count,
    dataURL: file.dataURL,
    height: file.height,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    manuallyAdded: file.manuallyAdded,
    name: file.name,
    processing: file.processing,
    size: file.size,
    status: file.status,
    type: file.type,
    upload: file.upload
      ? {
          uuid: file.upload.uuid,
          progress: file.upload.progress,
          total: file.upload.total,
          bytesSent: file.upload.bytesSent,
          filename: file.upload.filename,
        }
      : null,
    webkitRelativePath: file.webkitRelativePath,
    width: file.width,
    xhr: file.xhr
      ? {
          readyState: file.xhr.readyState,
          status: file.xhr.status,
          response: file.xhr.response,
          responseText: file.xhr.responseText,
        }
      : null,
  }
}

/**
 * データをシリアライズ（ファイル配列を含む）
 * @param {*} data - シリアライズするデータ
 * @returns {*} シリアライズされたデータ
 */
function serializeData(data) {
  if (!data) return data

  if (Array.isArray(data)) {
    return data.map((item) => serializeData(item))
  }

  if (typeof data === 'object') {
    const serialized = {}
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key]

        // ファイルっぽいオブジェクト（nameとsizeとtypeがある）
        if (
          value &&
          typeof value === 'object' &&
          'name' in value &&
          'size' in value &&
          'type' in value &&
          !Array.isArray(value)
        ) {
          serialized[key] = serializeFile(value)
        } else if (Array.isArray(value)) {
          // 配列の場合、各要素をチェック
          serialized[key] = value.map((item) => {
            if (
              item &&
              typeof item === 'object' &&
              'name' in item &&
              'size' in item &&
              'type' in item
            ) {
              return serializeFile(item)
            }
            return serializeData(item)
          })
        } else if (value && typeof value === 'object') {
          serialized[key] = serializeData(value)
        } else {
          serialized[key] = value
        }
      }
    }
    return serialized
  }

  return data
}

/**
 * 一時保存データを保存する
 * @param {string} type - 'transport' または 'vehicle'
 * @param {Object} data - 保存するデータ {form, syaryos?, option?}
 */
export function saveTempData(type, data) {
  try {
    const serializedData = serializeData(data)

    const saveData = {
      type,
      data: serializedData,
      timestamp: Date.now(),
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(saveData))
    return true
  } catch (error) {
    console.error('一時保存に失敗しました:', error)
    return false
  }
}

/**
 * 一時保存データを取得する
 * @returns {Object|null} 保存データ、存在しない場合はnull
 */
export function getTempData() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (!saved) {
      return null
    }
    return JSON.parse(saved)
  } catch (error) {
    console.error('一時保存データの取得に失敗しました:', error)
    return null
  }
}

/**
 * 一時保存データを削除する
 */
export function removeTempData() {
  try {
    localStorage.removeItem(STORAGE_KEY)
    return true
  } catch (error) {
    console.error('一時保存データの削除に失敗しました:', error)
    return false
  }
}

/**
 * 一時保存データが存在するかチェックする
 * @returns {boolean}
 */
export function hasTempData() {
  const data = getTempData()
  return data !== null
}



// WEBPACK FOOTER //
// ./src/components/order/utils/orderTempSave.js